'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;

        _this.close = function () {
            return _this.setState({ active: false });
        };

        _this.open = function () {
            return _this.setState({ active: true });
        };

        _this.toggle = function () {
            return _this.setState({ active: !_this.state.active });
        };

        _this._handleItemKeyDown = function () {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (event.nativeEvent && event.keyCode === 13) {
                _this.close();
            }

            return _this;
        };

        _this._handleItemClick = function () {
            _this.close();
            return _this;
        };

        _this._handleClick = function () {
            _this.toggle();
            return _this;
        };

        _this._handleBodyClick = function () {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (_this.state.active && !_this.root.contains(event.target)) {
                _this.close();
            }

            return _this;
        };

        _this._handleMouseEnter = function () {
            return _this.setState({ hover: true });
        };

        _this._handleMouseLeave = function () {
            return _this.setState({ hover: false });
        };

        _this._rootRef = function (el) {
            return _this.root = el;
        };

        _this.state = {
            active: false,
            hover: false
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    return Main;
}(_Component3.default);

Main.defaultProps = {
    dirLeft: false
};
Main.propTypes = {
    dirLeft: _propTypes2.default.bool,
    style: _propTypes2.default.object,
    icon: _propTypes2.default.any
};
Main.displayName = 'Options';
exports.default = Main;